import React from 'react'
import Style from './PaymentSituation.module.css'
import { separate } from '../../../../Utils/SeprateNumber/SeprateThreeNumber'
const PaymentSituation = ({info}) => {
  return (
     <fieldset className={Style.fieldSetHolder}>
    <legend>اطلاعت پرداخت درخواست</legend>
    <div>
        <strong >وضعیت پرداخت:</strong>
        <span>{info?.paid==="0"?"پرداخت نشده":"پرداخت شده"}</span>
    </div>
    <div>
        <strong>هزینه :</strong>
        <span style={{color:"green"}}>{separate(info?.delivery)}تومان</span>
    </div>
    <div>
        <strong >سهم پیک:</strong>
        <span style={{color:"red"}}>{separate(info?.driver)}تومان</span>
    </div>
    <div>
        <strong >سهم برست:</strong>
        <span style={{color:"red"}}>{separate(info?.delivery-info?.driver)}تومان</span>
    </div>

    
  </fieldset>
  )
}

export default PaymentSituation